import { MeetingPageType } from '../enums'

export class MeetingPage {
    id!: string
    meetingId!: string
    order!: number
    pageType!: MeetingPageType
    title!: string
    subheading!: boolean
    duration!: number
}
